import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, Renderer, ViewChild } from '@angular/core';
import { InstituicaoEnsino } from 'src/app/model/instituicaoEnsino.model';
import { AgendamentoService } from 'src/app/services/agendamento.service';
import { PaymentService } from 'src/app/services/payment.service';
import { IbgeService } from 'src/app/services/ibge.service';
import { Local } from 'src/app/model/local.model';
import { Data } from 'src/app/model/data.model';
import { Agendamento } from 'src/app/model/agendamento.model';
import { ImagemEnviada } from 'src/app/model/imagemEnviada.model';
import { WizardComponent } from 'src/app/component/wizard/index';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Result } from 'src/app/model/result.model';
import { GenericValidator } from 'src/app/generic-validator';
import { DatePipe, formatDate } from '@angular/common';
import _ from 'lodash';
import * as moment from 'moment';
import creditCardType from 'credit-card-type';
import { LinhaOnibus } from 'src/app/model/linhaOnibus.model';
import { FileUpload } from 'primeng/fileupload';
import { Usuario } from 'src/app/model/usuario.model';
import { Mask } from 'src/app/model/mask.model';
import { first } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { RequiredDocs } from 'src/app/model/servico.model';
import { CardFlagType } from 'src/app/model/pagamento.model';
import { Cidade } from 'src/app/model/cidade.model';
import { Frete } from 'src/app/model/frete.model';
import { ResultCEP } from 'src/app/model/resultCEP.model';
import * as Nacionalidades from 'src/app/enum/nacionalidades.json';
import * as Estados from 'src/app/enum/estados.json';
import { Autolinker } from 'autolinker';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { CustomSiteService } from '../../services/customsite.service';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
    selector: 'app-agendamento',
    templateUrl: './agendamento.component.html',
    styleUrls: ['./agendamento.component.css']
    // encapsulation: ViewEncapsulation.None
})
export class AgendamentoComponent implements OnInit, AfterViewInit {
    @ViewChild('form1', { static: false }) formInfPessoal: HTMLFormElement;
    @ViewChild('form2', { static: false }) formEmpresa: HTMLFormElement;
    @ViewChild('form3', { static: false }) formEscola: HTMLFormElement;
    @ViewChild('form4', { static: false }) formPagamento: HTMLFormElement;
    @ViewChild(WizardComponent, { static: true }) wizard: WizardComponent;
    @ViewChild('institutionCourseEndYear', { static: false }) institutionCourseEndYearInput: ElementRef;
    search: String;
    cpfmask = Mask.cpf;
    cnpjmask = Mask.cnpj;
    telefonemask = Mask.telefone;
    datamask = Mask.data;
    cepmask = Mask.cep;
    institutionCourseEndYearValue: string = '';
    cursor = 0;
    instituicoes: InstituicaoEnsino[];
    linhaOnibus: LinhaOnibus[];
    dadosIniciaisAgendamento: any = {};
    locais: Local[];
    locaisRetirada: Local[];
    datas: Data[];
    datasGrouped: any;
    datasCustom: [];
    horasCustom: [];
    dataSelecionada: String;
    horaSelecionada: String;
    model: Agendamento;
    etapas: any;
    btnVoltar: any;
    btnFinalizar: any;
    btnAvancar: any;
    resultado: Result;
    fileInputFilled = false;
    currentDate: Date;
    concluido = false;
    erro = false;
    showSpinner = false;
    stepAgendamento = false;
    emailDisabled = true;
    mostrarCheckbox: boolean = false;
    type: String;
    newRequiredDocs: RequiredDocs[];
    requiredDocsSent: RequiredDocs[];
    allRequiredDocsSent: Boolean;
    invalidYear: Boolean;
    cardFlagName: String;
    valueToPayFormatted: String;
    cidades: Cidade[];
    fretes: Frete[];
    resultCep: ResultCEP;
    nacionalidades: String[] = (Nacionalidades as any).default;
    estados: Object[] = (Estados as any).default;
    personalInfoValidatorCache = new Map();
    postedUseTermsLog = false;
    sentDocumentMap = new Map<RequiredDocs, Number>();
    errorMessage: String = '';
    pageTitle = "Atendimento - Pagmob";

    constructor(private agendamentoService: AgendamentoService, private paymentService: PaymentService, private datePipe: DatePipe, private renderer: Renderer,
        private elem: ElementRef, private route: ActivatedRoute, private router: Router, public datepipe: DatePipe, private _notificationService: NotificationsService,
        public googleAnalyticsService: GoogleAnalyticsService, private ibgeService: IbgeService, private cdr: ChangeDetectorRef, private customSiteService: CustomSiteService,
        private configService: ConfigurationService) {
        /** type define se é um novo agendamento ou uma edição */
        this.type = route.snapshot.data["type"];
    }

    ngOnInit() {
        this.googleAnalyticsService.eventEmitter("agendamento", "load", "page-load", 1);

        this.agendamentoService.getIp().subscribe(ip => {
            localStorage.setItem('clientIP', ip);
        });


        const us = <Usuario>JSON.parse(localStorage.getItem('usuario'));

        this.dadosIniciaisAgendamento = JSON.parse(localStorage.getItem('dadosIniciaisAgendamento'));

        if (this.dadosIniciaisAgendamento.servico.valueToPay != null) {
            this.dadosIniciaisAgendamento.servico.valueToPayFormatted = this.dadosIniciaisAgendamento.servico.valueToPay.toFixed(2);
            this.dadosIniciaisAgendamento.servico.shippingFee = 0;
            this.dadosIniciaisAgendamento.servico.shippingFeeFormatted = this.dadosIniciaisAgendamento.servico.shippingFee.toFixed(2);
            this.dadosIniciaisAgendamento.servico.totalValue = this.dadosIniciaisAgendamento.servico.valueToPay;
            this.dadosIniciaisAgendamento.servico.totalValueFormatted = this.dadosIniciaisAgendamento.servico.totalValue.toFixed(2);
        }

        this.requiredDocsSent = [];
        if (this.type == 'add') {
            this.model = new Agendamento();
            this.model.requirerType = 'M';
            this.model.userData = us;
            this.cidades = [];

            if (this.dadosIniciaisAgendamento.servico.hasShipping) {
                this.model.shippingInfo = new Usuario();
            }

            if (this.model.userData.email == '' || this.model.userData.email == null) {
                this.emailDisabled = false;
            }

            this.atualizarCidades(this.model.userData.state);

            if (this.model.userData.birthDate) {
                this.model.userData.birthDate2 = this.datepipe.transform(moment(this.model.userData.birthDate).toDate(), 'dd/MM/yyyy');
            }
            if (this.model.userData.rgEmission) {
                this.model.userData.rgEmissionString = this.datepipe.transform(moment(this.model.userData.birthDate).toDate(), 'dd/MM/yyyy');
            }



            this.model.agencyId = this.dadosIniciaisAgendamento.agenciaId;
            this.model.createdDate = Date.now();
            this.model.serviceId = this.dadosIniciaisAgendamento.servico.id;
            this.model.serviceName = this.dadosIniciaisAgendamento.servico.serviceName;
            this.model.serviceTypeVO = this.dadosIniciaisAgendamento.servico.serviceTypeList[0];


            this.allRequiredDocsSent = true;
            var filtered = this.dadosIniciaisAgendamento.servico.requiredDocs.filter(function (d) {
                return d.required === true;
            });
            if (filtered.length > 0) {
                this.allRequiredDocsSent = false;
            }

            this.verificaDelivery();
        } else {
            this.model = this.dadosIniciaisAgendamento.agendamento;
            this.model.attachmentList = [];
            if (this.model.userData.birthDate) {
                this.model.userData.birthDate2 = this.datepipe.transform(moment(this.model.userData.birthDate).toDate(), 'dd/MM/yyyy');
            }
            if (this.model.userData.rgEmission) {
                this.model.userData.rgEmissionString = this.datepipe.transform(moment(this.model.userData.rgEmission).toDate(), 'dd/MM/yyyy');
            }
            this.newRequiredDocs = [];
            for (let y = 0; y < this.dadosIniciaisAgendamento.servico.requiredDocs.length; y++) {
                for (let i = 0; i < this.model.pendingDataList.length; i++) {
                    if (this.model.pendingDataList[i].type == 'ATTACHMENT_DATA' && this.dadosIniciaisAgendamento.servico.requiredDocs[y].code == this.model.pendingDataList[i].name) {
                        this.newRequiredDocs.push(this.dadosIniciaisAgendamento.servico.requiredDocs[y]);
                    }
                }
            }
            this.dadosIniciaisAgendamento.servico.requiredDocs = this.newRequiredDocs;
        }
        this.model.abtServiceTypeId = this.dadosIniciaisAgendamento.servico.serviceTypeId;

        this.dadosIniciaisAgendamento.servico.requiredDocs.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            return 0;
        });

        this.getLocais();
        this.getLocaisRetirada();
        this.getFrete();
        const pageTitle = sessionStorage.getItem("pageTitle");
        if (pageTitle == null)
            this.configService.loadConfigurations().subscribe(config => {
                this.customSiteService.login(config.agencyId).subscribe(customsite => {
                    if (customsite.pageTitle) {
                        this.pageTitle = customsite.pageTitle;
                        sessionStorage.setItem("pageTitle", this.pageTitle);
                    }
                    if (customsite.pageTitle) sessionStorage.setItem("loginText", customsite.loginText);
                    if (customsite.loginObs) sessionStorage.setItem("loginObs", customsite.loginObs);
                    if (customsite.popUp) sessionStorage.setItem("popUp", customsite.popUp);
                    if (customsite.privacy) sessionStorage.setItem("privacy", customsite.privacy);
                    if (customsite.termsAcceptance) sessionStorage.setItem("termsAcceptance", customsite.termsAcceptance);
                    if (customsite.register) sessionStorage.setItem("register", customsite.register);
                });
            });
        else {
            this.pageTitle = pageTitle;
        }
    }

    validateYear(year: string): void {
        const currentYear = new Date().getFullYear();
        const yearInt = parseInt(currentYear.toString(), 10)
        const inputYear = parseInt(year, 10);
        if (!isNaN(inputYear) && inputYear < yearInt) {
            this.invalidYear = true;
            this.limparCampo();
            
        } else {
            this.invalidYear = false;
        }
    }

    limparCampo(): void {
        const inputElement = document.getElementById('institutionCourseEndYear') as HTMLInputElement;
        if (inputElement) {
            inputElement.value = null; 
            this.formEscola.controls['institutionCourseEndYear'].setErrors({'required': true});
        }
    }

    ngAfterViewInit() {
        // setTimeout(wizardCallback => {
        this.etapas = this.wizard.steps;
        const elements = this.elem.nativeElement.querySelectorAll('.btn.btn-wizard ');
        this.cdr.detectChanges();

        elements.forEach(element => {
            if (element.textContent === 'Next') {
                this.btnAvancar = element;
                element.textContent = 'Próximo';
                element.addEventListener('click', () => this.onButtonClick());
            }
            if (element.textContent === 'Done') {
                this.btnFinalizar = element;
                element.textContent = 'Finalizar';
            }
            if (element.textContent === 'Previous') {
                this.btnVoltar = element;
                element.textContent = 'Voltar';
            }
        });
        // }, 0);
    }

    habilitarCheckBox() {
        var socialName = this.model.userData.socialName;
        if (socialName.length > 0) {
            this.mostrarCheckbox = true;
        } else {
            this.mostrarCheckbox = false;
        }
    }

    onButtonClick() {
        if (this.wizard.activeStep.title === 'Documentos') {
            this.showSpinner = false;
        }
    }

    voltar() {
        this.cursor = this.wizard.steps.indexOf(this.wizard.activeStep)
        this.cursor--;
    }

    async avancar() {
        this.showSpinner = true;
        this.concluido = false;
        this.erro = false;
        this.search = '';

        if (!this.postedUseTermsLog) {
            this.postedUseTermsLog = true;
        }

        this.cursor = this.wizard.steps.indexOf(this.wizard.activeStep) + 1;

        if (this.wizard.steps.length === this.wizard.steps.indexOf(this.wizard.activeStep) + 2) {
            this.model.ip = localStorage.getItem('clientIP');
            if (this.model.requirerType == 'M') {
                localStorage.setItem('usuario', JSON.stringify(this.model.userData));
            }

            if (this.dadosIniciaisAgendamento.servico.appointment) {
                let localId = this.model.serviceLocationId;
                let localName = this.model.serviceLocation;
                if (localId) {
                    var obj = this.locais.filter(function (node) {
                        return node.id == localId;
                    });
                    if (obj.length > 0) {
                        this.model.serviceLocationAddress = obj[0].address;
                    }
                }
                if (localName) {
                    var objAux = this.locais.filter(function (node) {
                        return node.name = localName;
                    })
                    if (objAux.length > 0) {
                        this.model.serviceLocationAddress = objAux[0].address;
                    }
                }


                if (this.type == 'add') {
                    this.model.busServiceVOList.forEach(item => {
                        item.serviceId = item.id;
                        item.serviceCode = item.routeCode;
                        item.serviceDescription = item.serviceMnemonic;
                    });
                    this.agendamentoService.postAgendamento(this.model).pipe(first()).subscribe((result: Result) => {
                        this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "novo-agendamento", 2);

                        if (result.success) {
                            this.concluido = true;
                            this.erro = false;
                            this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "sucesso", 3);
                        } else {
                            this.concluido = false;
                            this.erro = true;
                            this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "erro_negocio", 5);
                        }

                        this.resultado = result;
                        this.currentDate = new Date();
                        this.showSpinner = false;
                    }, (err) => {
                        this.showSpinner = false;
                        this.concluido = false;
                        this.erro = true;
                        this.resultado = err;
                        this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "erro", 4);
                        // this.cursor -= 1;
                    });
                } else {
                    this.fillPendingDataValues();

                    this.agendamentoService.editAgendamento(this.model.userData.cpf, this.model.agencyId, this.model.protocol, this.model.pendingDataList).pipe(first()).subscribe((result: Result) => {
                        this.showSpinner = false;
                        this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "edit-solicitação", 2);
                        if (result.success) {
                            this.concluido = true;
                            this.erro = false;
                            this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "sucesso_edit", 3);
                        } else {
                            this.concluido = false;
                            this.erro = true;
                            this.btnVoltar.visible = false;
                            this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "erro_negocio_edit", 5);
                        }
                        this.resultado = result;
                        this.currentDate = new Date();
                    }, (err) => {
                        this.showSpinner = false;
                        this.concluido = false;
                        this.erro = true;
                        this.resultado = err;
                        this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "erro_edit", 4);
                    });
                }
            } else {
                if (this.type == 'add') {
                    this.model.busServiceVOList.forEach(item => {
                        item.serviceId = item.id;
                        item.serviceCode = item.routeCode;
                        item.serviceDescription = item.serviceMnemonic;
                        if (this.model.requireSocialName == null) {
                            this.model.requireSocialName = false;
                        }
                    });
                    this.agendamentoService.postSolicitacao(this.model).pipe(first()).subscribe((result: Result) => {
                        this.showSpinner = false;

                        this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "nova-solicitação", 2);

                        if (result.success) {
                            this.concluido = true;
                            this.erro = false;
                            this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "sucesso", 3);
                        } else {
                            this.concluido = false;
                            this.erro = true;
                            this.btnVoltar.visible = false;
                            this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "erro_negocio", 5);
                        }

                        this.resultado = result;
                        this.currentDate = new Date();
                    }, (err) => {
                        this.showSpinner = false;
                        this.concluido = false;
                        this.erro = true;
                        this.resultado = err;
                        this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "erro", 4);
                    });
                } else {
                    this.fillPendingDataValues();

                    this.agendamentoService.editAgendamento(this.model.userData.cpf, this.model.agencyId, this.model.protocol, this.model.pendingDataList).pipe(first()).subscribe((result: Result) => {
                        this.showSpinner = false;
                        this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "edit-solicitação", 2);
                        if (result.success) {
                            this.concluido = true;
                            this.erro = false;
                            this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "sucesso_edit", 3);
                        } else {
                            this.concluido = false;
                            this.erro = true;
                            this.btnVoltar.visible = false;
                            this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "erro_negocio_edit", 5);
                        }
                        this.resultado = result;
                        this.currentDate = new Date();
                    }, (err) => {
                        this.showSpinner = false;
                        this.concluido = false;
                        this.erro = true;
                        this.resultado = err;
                        this.googleAnalyticsService.eventEmitter("agendamento", "button-click", "erro_edit", 4);
                    });
                }
            }
        }//if last step ?

        if (this.stepAgendamento)
            this.showSpinner = false;
    }

    handleSocialNameChange() {
        this.model.requireSocialName = this.formInfPessoal.form.controls['requireSocialName'].value;
        console.log(this.model.requireSocialName);
    }

    fillPendingDataValues() {
        for (let i = 0; i < this.model.pendingDataList.length; i++) {
            if (this.model.pendingDataList[i].type == 'PERSONAL_DATA') {
                if (this.model.pendingDataList[i].name == 'nome') {
                    this.model.pendingDataList[i].value = this.model.userData.fullName;
                } else if (this.model.pendingDataList[i].name == 'nomeMae') {
                    this.model.pendingDataList[i].value = this.model.userData.motherFullName;
                } else if (this.model.pendingDataList[i].name == 'nomePai') {
                    this.model.pendingDataList[i].value = this.model.userData.fatherFullName;
                } else if (this.model.pendingDataList[i].name == 'email') {
                    this.model.pendingDataList[i].value = this.model.userData.email;
                } else if (this.model.pendingDataList[i].name == 'cpf') {
                    this.model.pendingDataList[i].value = this.model.userData.cpf;
                } else if (this.model.pendingDataList[i].name == 'rg') {
                    this.model.pendingDataList[i].value = this.model.userData.rg;
                } else if (this.model.pendingDataList[i].name == 'telefone') {
                    this.model.pendingDataList[i].value = this.model.userData.phoneNumber;
                } else if (this.model.pendingDataList[i].name == 'birthDate') {
                    this.model.pendingDataList[i].value = this.model.userData.birthDate.toString();
                } else if (this.model.pendingDataList[i].name == 'sexo') {
                    this.model.pendingDataList[i].value = this.model.userData.gender;
                } else if (this.model.pendingDataList[i].name == 'numeroCartao') {
                    this.model.pendingDataList[i].value = this.model.transportCardNumber;
                } else if (this.model.pendingDataList[i].name == 'nacionalidade') {
                    this.model.pendingDataList[i].value = this.model.userData.nacionalidade;
                } else if (this.model.pendingDataList[i].name == 'estadoCivil') {
                    this.model.pendingDataList[i].value = this.model.userData.estadoCivil;
                } else if (this.model.pendingDataList[i].name == 'responsavel') {
                    this.model.pendingDataList[i].value = this.model.userData.responsavel;
                } else if (this.model.pendingDataList[i].name == 'telefoneCelular') {
                    this.model.pendingDataList[i].value = this.model.userData.telefoneCelular;
                } else if (this.model.pendingDataList[i].name == 'rgEmission') {
                    this.model.pendingDataList[i].value = this.model.userData.rgEmission.toString();
                } else if (this.model.pendingDataList[i].name == 'rgAuthority') {
                    this.model.pendingDataList[i].value = this.model.userData.rgAuthority;
                } else if (this.model.pendingDataList[i].name == 'rgState') {
                    this.model.pendingDataList[i].value = this.model.userData.rgState;
                }
                else if (this.model.pendingDataList[i].name == 'socialName') {
                    this.model.pendingDataList[i].value = this.model.userData.socialName;
                }
            } else if (this.model.pendingDataList[i].type == 'ADDRESS_DATA') {
                if (this.model.pendingDataList[i].name == 'cep') {
                    this.model.pendingDataList[i].value = this.model.userData.cep;
                } else if (this.model.pendingDataList[i].name == 'endereco') {
                    this.model.pendingDataList[i].value = this.model.userData.address;
                } else if (this.model.pendingDataList[i].name == 'numero') {
                    this.model.pendingDataList[i].value = this.model.userData.addressNumber;
                } else if (this.model.pendingDataList[i].name == 'complemento') {
                    this.model.pendingDataList[i].value = this.model.userData.addressComplement;
                } else if (this.model.pendingDataList[i].name == 'bairro') {
                    this.model.pendingDataList[i].value = this.model.userData.neighborhood;
                } else if (this.model.pendingDataList[i].name == 'cidade') {
                    this.model.pendingDataList[i].value = this.model.userData.city;
                } else if (this.model.pendingDataList[i].name == 'estado') {
                    this.model.pendingDataList[i].value = this.model.userData.state;
                }
            } else if (this.model.pendingDataList[i].type == 'INSTITUTION_DATA') {
                if (this.model.pendingDataList[i].name == 'institutionName') {
                    this.model.pendingDataList[i].value = this.model.institutionData.institutionId.toString();
                } else if (this.model.pendingDataList[i].name == 'institutionCourseType') {
                    this.model.pendingDataList[i].value = this.model.institutionData.institutionCourseType;
                } else if (this.model.pendingDataList[i].name == 'institutionCoursePeriod') {
                    this.model.pendingDataList[i].value = this.model.institutionData.institutionCoursePeriod;
                } else if (this.model.pendingDataList[i].name == 'institutionCourseName') {
                    this.model.pendingDataList[i].value = this.model.institutionData.institutionCourseName;
                } else if (this.model.pendingDataList[i].name == 'institutionEnrollmentId') {
                    this.model.pendingDataList[i].value = this.model.institutionData.institutionEnrollmentId;
                } else if (this.model.pendingDataList[i].name == 'institutionCourseYear') {
                    this.model.pendingDataList[i].value = this.model.institutionData.institutionCourseYear;
                } else if (this.model.pendingDataList[i].name == 'institutionCourseDuration') {
                    this.model.pendingDataList[i].value = this.model.institutionData.institutionCourseDuration;
                } else if (this.model.pendingDataList[i].name == 'institutionCourseEndYear') {
                    this.model.pendingDataList[i].value = this.model.institutionData.institutionCourseEndYear;
                }
            }
        }
    }

    menor() {
        return moment.duration(moment().diff(moment(this.model.userData.birthDate))).asYears() < 18;
    }

    alterarData(event) {
        const data = moment(event, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss');
        if (moment.duration(moment().diff(moment(data))).asYears() < 3)
            this.formInfPessoal.form.controls['birthDate'].setErrors({ 'incorrect': true });
        this.model.userData.birthDate = this.convertDateToTimeStamp(event);
    }

    validarNomeSocial() {
        const nomeSocial = this.formInfPessoal.form.controls['socialName'].value;
        if (!/\s/.test(nomeSocial)) {
            this.formInfPessoal.controls['socialName'].setErrors({ 'invalidName': true });
        } else {
            this.formInfPessoal.controls['socialName'].setErrors(null);
        }
    }

    alterarEmissao(event) {
        this.model.userData.rgEmission = this.convertDateToTimeStamp(event);
    }

    convertDateToTimeStamp(date) {
        const data = moment(date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss');
        return moment(data).unix() * 1000;
    }

    onStep1Next(event) {
        this.avancar();
    }

    onStep2Next(event) {
        this.avancar();
    }

    onStep3Next(event) {
        this.avancar();
    }

    onStep4Next(event) {
        this.avancar();
    }

    onStep5Next(event) {
        this.avancar();
    }

    onStep6Next(event) {
        const data = moment(this.dataSelecionada + ' ' + this.horaSelecionada, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss');
        this.model.selectedDate = moment(data).unix() * 1000;
        this.avancar();
    }

    onStep7Next(event) {
        this.avancar();
    }

    onStep8Next(event) {
        this.avancar();
    }

    onStep9Next(event) {
        this.dadosIniciaisAgendamento.servico.shippingFee = this.model.pagamento.additionalValue;
        this.dadosIniciaisAgendamento.servico.shippingFeeFormatted = this.dadosIniciaisAgendamento.servico.shippingFee.toFixed(2);
        this.dadosIniciaisAgendamento.servico.totalValue = this.dadosIniciaisAgendamento.servico.valueToPay + this.dadosIniciaisAgendamento.servico.shippingFee;
        this.dadosIniciaisAgendamento.servico.totalValueFormatted = this.dadosIniciaisAgendamento.servico.totalValue.toFixed(2);
        this.avancar();
    }

    onStep10Next(event) {
        this.avancar();
    }

    onStep11Next(event) {
        this.avancar();
        this.model.ip = localStorage.getItem('clientIP');
    }

    onStep12Next(event) {
        if (this.model.requirerType == 'T') {
            var newUserData = new Usuario();
            newUserData.userId = this.model.userData.userId;
            this.model.userData = newUserData;
        } else {
            this.model.userData = <Usuario>JSON.parse(localStorage.getItem('usuario'))
            this.model.userData.birthDate2 = this.datepipe.transform(moment(this.model.userData.birthDate).toDate(), 'dd/MM/yyyy')
            this.model.userData.rgEmissionString = this.datepipe.transform(moment(this.model.userData.rgEmission).toDate(), 'dd/MM/yyyy')
        }
        this.avancar();
    }

    onStep13Next(event) {
        this.avancar();
    }

    onComplete(event) {
        this.router.navigate(['app/dashboard']);
    }

    getInstituicaoEnsino() {
        this.instituicoes = [];
        this.agendamentoService.getInstituicaoEnsino(this.model.agencyId, this.search).pipe(first()).subscribe((result: InstituicaoEnsino[]) => {
            this.instituicoes = result;
        });
    }

    selecionaInstituicaoEnsino(instituicao) {
        this.model.institutionData = instituicao;
        this.model.institutionData.institutionId = instituicao.id;

        const element: HTMLElement = document.getElementById('fecharModal') as HTMLElement;
        element.click();
    }

    // para agendamentos
    alterarLocal() {
        this.showSpinner = true;
        let locaisFilter = this.locais.filter(x => x.id == this.model.serviceLocationId);
        this.datasCustom = [];
        this.horasCustom = [];
        this.dataSelecionada = null;
        this.horaSelecionada = null;

        if (locaisFilter) {
            this.model.serviceLocation = locaisFilter[0].name;
            this.model.serviceLocationAddress = locaisFilter[0].address;
            this.getDatasCustomizadas();
        } else {
            this.showSpinner = false;
        }
    }

    // para retirada (requiredLocation)
    alterarLocation() {
        let locaisFilter = this.locais.filter(x => x.id == this.model.serviceLocationId);

        if (locaisFilter) {
            this.model.serviceLocation = locaisFilter[0].name;
            this.model.serviceLocationAddress = locaisFilter[0].address;
        }
    }

    getLocais() {
        const agenciaId = this.model.agencyId;
        const tipoServidoId = this.model.serviceTypeVO.id;

        if (this.dadosIniciaisAgendamento.servico.appointment) {
            this.agendamentoService.getLocal(agenciaId, tipoServidoId).pipe(first()).subscribe((result: Local[]) => {
                this.locais = result;
                if (this.locais.length === 1) {
                    this.model.serviceLocationId = this.locais[0].id;
                    this.model.serviceLocation = this.locais[0].name;
                    this.model.serviceLocationAddress = this.locais[0].address;
                    this.getDatasCustomizadas();
                }
            });
        }
    }

    getLocaisRetirada() {
        const agenciaId = this.model.agencyId;
        const servicoId = this.dadosIniciaisAgendamento.servico.id;
        const tipoServidoId = this.model.serviceTypeVO.id;
        if (!this.dadosIniciaisAgendamento.servico.appointment && this.dadosIniciaisAgendamento.servico.requireLocation) {
            this.agendamentoService.getLocalRetirada(agenciaId, servicoId, tipoServidoId).pipe(first()).subscribe((result: Local[]) => {
                this.locaisRetirada = result;
            });
        }
    }

    getFrete() {
        const agenciaId = this.model.agencyId;
        const servicoId = this.dadosIniciaisAgendamento.servico.id;
        const tipoServidoId = this.model.serviceTypeVO.id;
        if (!this.dadosIniciaisAgendamento.servico.appointment && this.dadosIniciaisAgendamento.servico.hasShipping) {
            this.agendamentoService.getFrete(agenciaId, servicoId, tipoServidoId).pipe(first()).subscribe((result: Frete[]) => {
                this.fretes = result;
            });
        }
    }

    getLinhas() {
        const search = (<HTMLInputElement>document.getElementById('searchLinha')).value;
        this.agendamentoService.getLinhaOnibus(this.model.agencyId, search).pipe(first()).subscribe((result: LinhaOnibus[]) => {

            if (result.length > 0) {
                this.linhaOnibus = result;
                this.errorMessage = '';
            } else {
                this.linhaOnibus = [];
                this.errorMessage = "Nenhuma linha encontrada";
            }
        });
    }

    clearMessage() {
        this.errorMessage = "";
    }

    exibirAlertaLinhaMesmaRota(mensagem) {
        alert(mensagem);
    }

    adicionarLinha(linha) {
        if (this.model.busServiceVOList.find(l => l.routeCode == linha.routeCode)) {
            this.exibirAlertaLinhaMesmaRota("Não é necessário adicionar duas linhas da mesma rota. A rota é valida para ida e volta.");
        }
        else if (!this.model.busServiceVOList.find(l => l.id == linha.id)) this.model.busServiceVOList.push(linha);
        this.search = "";
        this.linhaOnibus = [];
        document.getElementById('fecharOutroModal').click();
    }

    removerLinha(id) {
        this.model.busServiceVOList = this.model.busServiceVOList.filter(item => item.id !== id);
    }

    alterarDatas() {
        this.agendamentoService.getData(this.model.agencyId, this.dadosIniciaisAgendamento.servico.id, this.model.serviceTypeVO.id, this.model.serviceLocationId).pipe(first()).subscribe((result: Data[]) => {
            this.datas = result;
        });
    }

    getDatasCustomizadas() {
        this.agendamentoService.getData(this.model.agencyId, this.dadosIniciaisAgendamento.servico.id, this.model.serviceTypeVO.id, this.model.serviceLocationId).pipe(first()).subscribe((result: Data[]) => {
            this.showSpinner = false;
            let dateFiltered = result.filter(data => data.remainingPermits > <Number>0);

            this.datasGrouped = _.groupBy(dateFiltered, function (n) {
                return formatDate(Number(n.fromTS), 'dd/MM/yyyy', 'pt-BR', '-0300');
            });

            const dt = dateFiltered.map(o => {
                return { id: o.id, value: formatDate(Number(o.fromTS), 'dd/MM/yyyy', 'pt-BR', '-0300') };
            });

            this.datasCustom = _.map(_.groupBy(dt, 'value'), (o, idx) => ({ data: idx }));

            this.getHora();
        });
    }

    getKeyValue(arr, value) {
        const index = Object.keys(arr).findIndex(item => item === value);
        const object = {
            key: function (n) {
                return this[Object.keys(this)[n]];
            }
        };

        function key(obj, idx) {
            return object.key.call(obj, idx);
        }

        return key(arr, index);
    }

    getHora() {
        const horarios = this.getKeyValue(this.datasGrouped, this.dataSelecionada);
        const horariosGrouped = _.groupBy(horarios, function (n) {
            return formatDate(Number(n.fromTS), 'HH:mm:ss', 'pt-BR', '-0300');
        });

        if (horarios != undefined) {
            const hr = horarios.map(o => {
                return { id: o.id, value: formatDate(Number(o.fromTS), 'HH:mm', 'pt-BR', '-0300') };
            });

            this.horasCustom = _.map(_.groupBy(hr, 'value'), (o, idx) => ({ hora: idx }));
        }
    }

    enviarArquivos(event, documento) {
        this.showSpinner = true;
        this.fileInputFilled = event.target.files && event.target.files.length > 0;
        const agenciaId = this.dadosIniciaisAgendamento.agenciaId;
        let mimetype = "png";
        let isSheet = false;

        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files.item(0);

            if (file.size > 10485760) {
                this.showSpinner = false;
                this._notificationService.error('Ops!', 'Tamanho da imagem está acima do permitido.');
                return;
            }

            if (GenericValidator.isValidSheetFormat(file.type)) {
                if (file.type == 'application/vnd.ms-excel') {
                    mimetype = "xls";
                } else {
                    mimetype = "xlsx";
                }
                isSheet = true;
            } else if (GenericValidator.isValidFileFormat(file.type)) {
                mimetype = file.type.split("/")[1];
            } else {
                this.showSpinner = false;
                this._notificationService.error('Ops!', 'Formato de arquivo não permitido.');
                return;
            }

            if (isSheet) {
                this.agendamentoService.enviaPlanilha(agenciaId, this.model.userData.cpf, mimetype, documento.code, file).pipe(first()).subscribe((result: ImagemEnviada) => {
                    this._notificationService.success('', 'Planilha enviada com sucesso.');
                    this.model.attachmentList.push(Number(result.attachmentId));
                    this.requiredDocsSent.push(documento);

                    this.validaArquivosEnviados(documento, result);

                    var appendElement = "<div class='font-weight-bold'>Planilha enviada. =)</div>";
                    event.target.parentElement.innerHTML = appendElement;
                }, (err) => {
                    this.showSpinner = false;
                    this._notificationService.success('Ops!', 'Ocorreu um erro na hora de enviar a planilha, por favor tente novamente.');
                });
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {

                    const imagem = { requestEntity: (<string>reader.result).split(',')[1] };

                    this.agendamentoService.enviaImagem(agenciaId, this.model.userData.cpf, mimetype, documento.code, imagem).subscribe(evnt => {
                        if (evnt.type == HttpEventType.UploadProgress) {
                            event.target.parentElement.firstElementChild.innerHTML = "<div class='progress'><div class='progress-bar progress-bar-striped progress-bar-animated' role='progressbar' style='width: " + 100 * evnt.loaded / evnt.total + "%'></div></div>";
                        } else if (evnt instanceof HttpResponse) {
                            const result = <any>evnt.body;
                            if (result.responseCode == '500' || !result.success) {
                                this.showSpinner = false;
                                this._notificationService.error('Ops!', 'Ocorreu um erro ao enviar a imagem, por favor tente novamente.');
                            } else {
                                this._notificationService.success('', 'Imagem enviada com sucesso.');
                                this.showSpinner = false;

                                if (this.requiredDocsSent.includes(documento)) {
                                    const previous = this.sentDocumentMap.get(documento);
                                    this.model.attachmentList = this.model.attachmentList.filter(n => n != previous);
                                }
                                const attachmentId = Number(result.attachmentId);
                                this.model.attachmentList.push(attachmentId);
                                this.requiredDocsSent.push(documento);
                                this.sentDocumentMap.set(documento, attachmentId);

                                this.validaArquivosEnviados(documento, result);

                                if (event.target.parentElement.childNodes.length > 2) {
                                    event.target.parentElement.removeChild(event.target.parentElement.childNodes[1]);
                                    event.target.parentElement.removeChild(event.target.parentElement.childNodes[1]);
                                } else {
                                    event.target.parentElement.removeChild(event.target.parentElement.childNodes[1]);
                                }

                                var element = document.createElement('div');
                                element.innerHTML = "<div style='margin-top: 10px;'><img src='" + reader.result + "' width='20%'><br><div class='font-weight-bold' style='margin-top: 10px;'>Documento enviado.</div></div>";
                                event.target.parentElement.appendChild(element);

                                documento.required = false;
                                var formGroup = document.getElementById("imageFormGroup");
                                formGroup.style.cssText += 'margin-bottom:0rem';
                            }
                        }
                    }, (err) => {
                        this.showSpinner = false;
                        this._notificationService.error('Ops!', 'Ocorreu um erro ao enviar a imagem, por favor tente novamente.');
                    });
                };
            }


        }
    }

    validaArquivosEnviados(documento: RequiredDocs, arquivo: ImagemEnviada) {
        if (this.type == 'add') {
            this.allRequiredDocsSent = true;
            for (let d of this.dadosIniciaisAgendamento.servico.requiredDocs) {
                if (d.required === true) {
                    var found = false;
                    for (let dSent of this.requiredDocsSent) {
                        if (d.code === dSent.code) {
                            found = true;
                            break;
                        }
                    }
                    if (found === false) {
                        this.allRequiredDocsSent = false;
                        break;
                    }
                }
            }
            if (this.allRequiredDocsSent) {
                this._notificationService.success('', 'Todas os documentos obrigatórios foram enviados, você pode continuar para a próxima etapa.');
            }
        } else {
            for (let i = 0; i < this.model.pendingDataList.length; i++) {
                if (this.model.pendingDataList[i].type == 'ATTACHMENT_DATA' && documento.code == this.model.pendingDataList[i].name) {
                    this.model.pendingDataList[i].value = arquivo.attachmentId;
                }
            }
            var filtered = this.model.pendingDataList.filter(function (d) {
                return d.type === 'ATTACHMENT_DATA';
            });

            if (this.requiredDocsSent.length == filtered.length) {
                this.allRequiredDocsSent = true;
                this._notificationService.success('', 'Todas os documentos foram enviados, você pode continuar para a próxima etapa.');
            }
        }
    }

    getSizeInMegaBytes(file: File) {
        return file ? file.size / 1000000 : 0;
    }

    removeFile(file: File, uploader: FileUpload) {
        const index = uploader.files.indexOf(file);
        uploader.remove(null, index);
    }

    isEmailDisabled(): boolean {
        return this.emailDisabled;
    }

    isCpfValid(newValue: String) {
        if (!GenericValidator.isValidCpf(newValue)) {
            this.formInfPessoal.form.controls['cpf'].setErrors({ 'incorrect': true });
        } else {
            this.formInfPessoal.form.controls['cpf'].setErrors(null);
        }
    }

    isCnpjValid(newValue: string) {
        let valueFormatted = newValue.replace('.', '').replace('/', '').replace('-', '');
        if (GenericValidator.isValidCnpj(valueFormatted)) {
            this.formEmpresa.form.controls['cnpj'].setErrors(null);
        } else {
            this.formEmpresa.form.controls['cnpj'].setErrors({ 'incorrect': true });
        }
    }

    isCardCpfValid(newValue: String) {
        let valueFormatted = newValue.replace('.', '').replace('.', '').replace('-', '');
        if (!GenericValidator.isValidCpf(valueFormatted)) {
            this.formPagamento.form.controls['cpfCard'].setErrors({ 'incorrect': true });
        } else {
            this.formPagamento.form.controls['cpfCard'].setErrors(null);
        }
    }

    /** Verifica se deve mostrar ou não o wizard-step */
    viewStep(stepName: String) {
        // novo agendamento
        const servico = this.dadosIniciaisAgendamento ? this.dadosIniciaisAgendamento.servico : {};

        if (this.type == 'add') {
            if (stepName == 'Descrição da solicitação' && servico.requireCustomerDescription) {
                return true;
            } else if (stepName == 'Solicitante' && servico.availableForThird) {
                return true;
            } else if (stepName == 'Dados da Empresa' && this.model.userData.empresa) {
                return true;
            } else if (stepName == 'Informações pessoais' && !this.model.userData.empresa) {
                return true;
            } else if (stepName == 'Endereço' && servico.requireAddress) {
                return true;
            } else if (stepName == 'Instituição de ensino' && servico.requireInstitution) {
                return true;
            } else if (stepName == 'Curso' && servico.requireInstitutionAdditionalData) {
                return true;
            } else if (stepName == 'Documentos' && servico.requiredDocs.length > 0) {
                return true;
            } else if (stepName == 'Agendamento' && servico.appointment) {
                this.stepAgendamento = true;
                return true;
            } else if (stepName == 'Linhas mais usadas' && servico.requireBusLineSelection) {
                return true;
            } else if (stepName == 'Termos e condições' && servico.mustAcceptTerms) {
                return true;
            } else if (stepName == 'Pagamento' && servico.hasPayment) {
                return true;
            } else if (stepName == 'Retirada' && ((servico.hasShipping && !servico.appointment) || (servico.requireLocation && !servico.appointment))) {
                return true;
            } else if (stepName == 'Lista Funcionários' && servico.requireEmployeeList) {
                return true;
            }
            // reenvio/ajuste de dados
        } else {
            if (stepName == 'Descrição da solicitação') {
                return false;
            } else if (stepName == 'Informações pessoais' && this.hasPendingType('PERSONAL_DATA')) {
                return true;
            } else if (stepName == 'Endereço' && this.hasPendingType('ADDRESS_DATA')) {
                return true;
            } else if (stepName == 'Instituição de ensino' && this.hasPendingTypeAndName('INSTITUTION_DATA', 'institutionName')) {
                return true;
            } else if (stepName == 'Curso' && this.hasPendingType('INSTITUTION_DATA')) {
                return true;
            } else if (stepName == 'Documentos' && this.hasPendingType('ATTACHMENT_DATA')) {
                return true;
            } else if (stepName == 'Agendamento') {
                return false;
            } else if (stepName == 'Linhas mais usadas') {
                return false;
            } else if (stepName == 'Termos e condições') {
                return false;
            }
        }
        return false;
    }

    /** Verifica se tem algum pendencia do tipo informado */
    hasPendingType(typeName: String) {
        for (let i = 0; i < this.model.pendingDataList.length; i++) {
            if (this.model.pendingDataList[i].type == typeName) {
                return true;
            }
        }
        return false;
    }

    hasPendingTypeAndName(typeName: String, fieldName: String) {
        for (let i = 0; i < this.model.pendingDataList.length; i++) {
            if (this.model.pendingDataList[i].type == typeName && this.model.pendingDataList[i].name == fieldName) {
                return true;
            }
        }
        return false;
    }

    disableField(typeName: String, fieldName: String) {
        if (this.type == 'add') {
            return false;
        } else {
            for (let i = 0; i < this.model.pendingDataList.length; i++) {
                if (this.model.pendingDataList[i].type == typeName && this.model.pendingDataList[i].name == fieldName) {
                    return false;
                }
            }
            return true;
        }
    }

    checkCardFlag(cardNumber: String) {
        let possibleCardFlags = creditCardType(cardNumber);

        if (possibleCardFlags.length === 1) {
            this.cardFlagName = possibleCardFlags[0].type;
            switch (this.cardFlagName) {
                case "visa":
                    this.model.pagamento.cardflag = CardFlagType.VISA;
                    break;
                case "mastercard": case "maestro":
                    this.model.pagamento.cardflag = CardFlagType.MASTER;
                    break;
                case "elo":
                    this.model.pagamento.cardflag = CardFlagType.ELO;
                    break;
                default:
                    this.model.pagamento.cardflag = null;
                    this.cardFlagName = null;
            }
        } else {
            this.model.pagamento.cardflag = null;
            this.cardFlagName = null;
        }
    }

    atualizarCidades(event) {
        if (event == null || event == '') {
            return;
        }
        this.showSpinner = true;
        this.ibgeService.getCidades(event).pipe(first()).subscribe((result: Cidade[]) => {
            this.showSpinner = false;
            this.cidades = result;
        }, (err) => {
            this.showSpinner = false;
            this._notificationService.success('Ops!', 'Ocorreu um erro ao carregar as cidades, tente alterar o Estado novamente.');
        });
    }

    alterarFrete(event) {
        this.model.pagamento.additionalValue = 0;
        for (let i = 0; i < this.fretes.length; i++) {
            if (this.fretes[i].id == event) {
                this.model.pagamento.additionalValue = this.fretes[i].value;
                break;
            }
        }
    }

    alterarLocalRetirada(event) {
        this.model.pagamento.additionalValue = 0;
        this.model.serviceLocation = null;
        this.model.serviceLocationAddress = null;
        for (let i = 0; i < this.locaisRetirada.length; i++) {
            if (this.locaisRetirada[i].id == event) {
                this.model.pagamento.additionalValue = this.locaisRetirada[i].shippingValue;
                this.model.serviceLocationAddress = this.locaisRetirada[i].address;
                this.model.serviceLocation = this.locaisRetirada[i].name;
                break;
            }
        }
    }

    carregaEntrega() {
        this.model.serviceLocationId = null;
        this.model.pagamento.additionalValue = 0;
        this.model.serviceShippingCostId = null;
        this.model.serviceLocation = null;
        this.model.serviceLocationAddress = null;
        if (this.model.delivery == 'E' && this.model.userData) {
            this.carregarEnderecoEntrega();
        }
    }

    verificaDelivery() {
        if (this.dadosIniciaisAgendamento.servico.hasShipping && !this.dadosIniciaisAgendamento.servico.requireLocation) {
            this.model.delivery = 'E';
            if (this.model.userData) {
                this.carregarEnderecoEntrega();
            }
        } else if (!this.dadosIniciaisAgendamento.servico.hasShipping && this.dadosIniciaisAgendamento.servico.requireLocation) {
            this.model.delivery = 'R';
        } else if (this.dadosIniciaisAgendamento.servico.hasShipping && this.dadosIniciaisAgendamento.servico.requireLocation) {
            this.model.delivery = 'R';
        } else {
            this.model.delivery = null;
        }
    }

    consultaCEP(cep: string, obj: Usuario) {
        if (cep.indexOf('_') >= 0 || cep.length < 9)
            return;

        let cleanCEP = cep.replace('-', '');
        this.ibgeService.getCEP(cleanCEP).pipe(first()).subscribe((result: ResultCEP) => {
            this.showSpinner = false;
            this.resultCep = result;
            obj.address = result.logradouro;
            obj.neighborhood = result.bairro;
            obj.state = result.uf;
            obj.city = result.localidade;
            this.atualizarCidades(obj.state);
        }, (err) => {
            this.showSpinner = false;
            this._notificationService.success('Ops!', 'Ocorreu um erro ao consultar o CEP, tente alterar o CEP novamente.');
        });
    }

    carregarEnderecoEntrega() {
        this.model.shippingInfo.address = this.model.userData.address;
        this.model.shippingInfo.addressNumber = this.model.userData.addressNumber;
        this.model.shippingInfo.addressComplement = this.model.userData.addressComplement;
        this.model.shippingInfo.cep = this.model.userData.cep;
        this.model.shippingInfo.neighborhood = this.model.userData.neighborhood;
        this.model.shippingInfo.city = this.model.userData.city;
        this.model.shippingInfo.state = this.model.userData.state;
    }

    checkExpireDate() {
        //check if whole "path" object is not null
        if (!this.model || !this.model.pagamento || !this.model.pagamento.expiremonth || !this.model.pagamento.expireyear) {
            return;
        }

        var today = new Date(),
            yearMonth = today.getFullYear() * 100 + today.getMonth(),
            inputMonth = parseInt(this.model.pagamento.expiremonth.toString()) - 1,
            inputYear = parseInt(this.model.pagamento.expireyear.toString()),
            inputYearMonth = inputYear * 100 + inputMonth;

        if (isNaN(inputMonth) || isNaN(inputYear)) {
            return;
        }

        if (today.getFullYear() <= inputYear && yearMonth <= inputYearMonth) {
            this.formPagamento.form.controls['expiremonth'].setErrors(null);
            this.formPagamento.form.controls['expireyear'].setErrors(null);
        } else {
            this.formPagamento.form.controls['expiremonth'].setErrors({ 'incorrect': true });
            if (today.getFullYear() > inputYear) //only month is wrong here
                this.formPagamento.form.controls['expireyear'].setErrors({ 'incorrect': true });
        }
    }

    hasExternalAPI() {
        const servico = this.dadosIniciaisAgendamento ? this.dadosIniciaisAgendamento.servico : {};
        return servico.hasExternalAPI;
    }

    personalInfoValid() {
        return this.personalInfoErrorMsg() == undefined
    }

    personalInfoErrorMsg() {
        const key = (this.model.userData.cpf == undefined ? "" : this.model.userData.cpf.toString()) + (this.model.userData.rg == undefined ? "" : this.model.userData.rg.toString())
        if (this.personalInfoValidatorCache.has(key))
            return this.personalInfoValidatorCache.get(key);
        else {
            this.personalInfoValidatorCache.set(key, undefined);
            if (this.router.url.includes("novo")) this.agendamentoService.postValid(this.model).pipe(first()).subscribe(result => {
                if (result.status == 'VALID') {
                    this.personalInfoValidatorCache.set(key, undefined);
                    return undefined;
                } else if (result.status == 'NOT_INVITED') {
                    this.personalInfoValidatorCache.set(key, result.message);
                    if (result.message != undefined && result.message != "") {
                        return result.message;
                    } else {
                        this.personalInfoValidatorCache.set(key, "Serviço exclusivo para convidados");
                        return "Serviço exclusivo para convidados";
                    }
                } else if (result.status == 'INVALID') {
                    this.personalInfoValidatorCache.set(key, result.message);
                    return result.message;
                } else if (result.status == 'ALREADY_SCHEDULED') {
                    this.personalInfoValidatorCache.set(key, "Esse serviço já foi agendado");
                    return "Esse serviço já foi agendado";
                }
            }, () => {
                this.personalInfoValidatorCache.set(key, undefined);
                return undefined;
            })
        }
    }

    link(text: string) {
        return Autolinker.link(text)
    }

    alterarRenda(event) {
        const value = event + "";
        if (isNaN(event) || value.includes('.') || value.includes(',') || value.includes('e'))
            this.formInfPessoal.form.controls['income'].setErrors({ 'incorrect': true });
        this.model.userData.birthDate = this.convertDateToTimeStamp(event);
    }
}
